import { Box, Step, StepLabel, Stepper, Typography } from "@mui/material";
import React from "react";
import AddNewProperty from "./AddNewProperty";
import AddNewProject from "pages/projects/AddNewProject";
import { useDispatch } from "react-redux";
import { addNewProperty } from "actions/propertyActions";
import { addUpdateProject } from "actions/projectActions";
import { useLocation, useNavigate } from "react-router-dom";

const steps = [
  { key: "property", label: "Location Details" },
  { key: "project", label: "Property Details" },
];

export const AddProjProperty = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { state = {} } = location;

  const [activeStep, setActiveStep] = React.useState(0);
  const [formState, setFormState] = React.useState({});

  console.log("Parent Form State", formState);

  const handleNext = React.useCallback(
    (data, key) => {
      if (activeStep < steps.length) {
        setFormState((prevState) => {
          return {
            ...prevState,
            [key]: data,
          };
        });
        setActiveStep((prevStep) => prevStep + 1);
      }
    },
    [activeStep]
  );

  const onSaveActionProperty = React.useCallback(
    (formData, filesState) => {
      handleNext({ formData, filesState }, steps[activeStep].key);
    },
    [handleNext, activeStep]
  );

  const retailProjectStateOnPreviousClick = React.useCallback(
    (formData, filesState) => {
      setFormState((prevState) => {
        return {
          ...prevState,
          project: { formData, filesState },
        };
      });
    },
    []
  );

  const onProjectCreationSuccess = React.useCallback(
    (propertyResponse, projectResponse) => {
      console.log("Project created successfully", projectResponse);
      navigate(
        `/properties/${projectResponse?.propertyId}/projects/${projectResponse.projectId}`,
        {
          state: {
            ...state,
            propertyName: propertyResponse.propertyName,
            propertyId: propertyResponse.propertyId,
            projectName: projectResponse.projectName,
            projectId: projectResponse.projectId,
          },
        }
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const onSaveActionProject = React.useCallback(
    ({ formData, filesData }) => {
      const { property } = formState;

      const onPropertySuccess = (propertyResponseData) => {
        console.log("Property created successfully", propertyResponseData);
        const propertyId = propertyResponseData.propertyId;
        dispatch(
          addUpdateProject({
            formData: { ...formData, propertyId },
            filesData,
            onSuccess: (projectResponse) =>
              onProjectCreationSuccess(propertyResponseData, projectResponse),
          })
        );
      };

      dispatch(
        addNewProperty(
          property.formData,
          property.filesState,
          onPropertySuccess
        )
      );
    },
    [formState, dispatch, onProjectCreationSuccess]
  );

  const onPreviousClick = React.useCallback(
    ({ formData, filesData }) => {
      setActiveStep(activeStep - 1);
      retailProjectStateOnPreviousClick(formData, filesData);
    },
    [activeStep, retailProjectStateOnPreviousClick]
  );

  const RenderPropertyForm = React.useCallback(() => {
    return (
      <AddNewProperty
        activeStep={activeStep}
        selectedProperty={{ data: formState.property?.formData || {} }}
        setActiveStep={setActiveStep}
        onSaveAction={onSaveActionProperty}
        restrictDefaultSave={true}
        hideTitleAndCloseButton={true}
        buttonText={"Next"}
      />
    );
  }, [activeStep, formState.property?.formData, onSaveActionProperty]);

  const RenderProjectForm = React.useCallback(() => {
    return (
      <AddNewProject
        activeStep={activeStep}
        selectedProject={{
          data: { ...formState.project?.formData, propertyId: "default" } || {},
        }}
        setActiveStep={setActiveStep}
        onSaveAction={onSaveActionProject}
        onCancel={onPreviousClick}
        restrictDefaultSave={true}
        hideTitleAndCloseButton={true}
        cancelButtonText={"Previous"}
        buttonText={"Create Property"}
      />
    );
  }, [
    activeStep,
    formState.project?.formData,
    onSaveActionProject,
    onPreviousClick,
  ]);

  const renderCurrentStep = () => {
    switch (activeStep) {
      case 0:
        return <RenderPropertyForm />;
      case 1:
        return <RenderProjectForm />;
      default:
        return null;
    }
  };

  return (
    <div className="proj-eqls-property-container mt-3 col-8 m-auto  justify-content-center">
      <Box className="">
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map(({ key, label }, index) => (
            <Step key={key}>
              <StepLabel>
                <Typography className="h3">{label}</Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
      <Box className="mt-4">{renderCurrentStep()}</Box>
    </div>
  );
};

export default AddProjProperty;
